
import {
  Button,
  Pagination,
  Popconfirm,
  Space,
  Table,
  Tag,
  Tooltip,
} from "antd";
import type { ColumnsType } from "antd/es/table";
import moment from "moment";
import { IoTrashOutline } from "react-icons/io5";
import { MdPreview } from "react-icons/md";
import { LuUndo2 } from "react-icons/lu";
import { useSelector } from "react-redux";
import { BiEdit } from "react-icons/bi";
import { useMemo } from "react";

function DataTable(props: any) {
  const User = useSelector((state: any) => state.User.user);

  interface DataType {
    key: string;
    id: number;
    edition: string;
    image: string;
    attributes: JSON;
    date: string;
  }

  const sortedData = useMemo(() => {
    if (!props.data || props.data.length === 0) return [];

    return [...props.data].sort((a: any, b: any) => {
      return moment(b.date).diff(moment(a.date));
    });
  }, [props.data]);

  const columns: ColumnsType<DataType> = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      width: 10,
      render: (text, record, index) => {
        return <strong>{index + 1}.</strong>;
      },
    },
    {
      title: "Preview",
      key: "image",
      dataIndex: "image",
      width: 20,
      render: (text, record: any) => {
        return (
          <div>
            {record?.image ? (
              <img
                key={record?.image}
                src={record?.image}
                alt="Table Image"
                style={{ height: 40, borderRadius: 6 }}
              />
            ) : (
              <div className="homescreen-table-NoImg">No media</div>
            )}
          </div>
        );
      },
    },
    {
      title: "Edition",
      dataIndex: "edition",
      key: "edition",
      width: 300,
      render: (text, record: any, index) => {
        return <div>{record?.edition}</div>;
      },
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      width: 100,
      render: (text, record: any, index) => {
        return <div>{moment(record?.date).format("DD-MM-YYYY")}</div>;
      },
    },
    {
      title: "No.Pages",
      width: 50,
      render: (text, record: any, index) => {
        return (
          <div>
            <strong>{record?.epapercollections?.length}</strong> Pages
          </div>
        );
      },
    },
    {
      title: "Status",
      width: 30,
      render: (text, record: any, index) => {
        return record?.publishedAt ? (
          <Tag color="green">Published</Tag>
        ) : (
          <Tag color="blue">Draft</Tag>
        );
      },
    },
    {
      title: "Action",
      key: "action",
      width: 10,
      render: (_, record: any) => {
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "space-evenly",
              alignContent: "center",
            }}
          >
            <Space size="middle" onClick={() => props.showPreview(record)}>
              <MdPreview size={20} cursor={"pointer"} color="#b72c6f" />
            </Space>
            <Space>
              <BiEdit
                size={20}
                color="#f5a442"
                cursor={"pointer"}
                onClick={() => props.onEdit(record)}
              />
            </Space>
            <Space size="middle" style={{ marginRight: 10 }}>
              <Tooltip
                title={`${
                  record?.is_deleted === true ? "Recover" : "Move"
                } From Trash`}
                color={"black"}
              >
                {record?.is_deleted === true ? (
                  <LuUndo2
                    color="blue"
                    size={20}
                    cursor={"pointer"}
                    onClick={() => props.unTrash(record)}
                  />
                ) : (
                  <IoTrashOutline
                    color="red"
                    size={20}
                    cursor={"pointer"}
                    onClick={() => props.onTrash(record)}
                  />
                )}
              </Tooltip>
            </Space>
            {record.is_deleted === true ? (
              <Popconfirm
                title="Delete the task"
                description="Are you sure to delete this task?"
                okText="Yes"
                cancelText="No"
                onConfirm={() => props.onDelete(record.id)}
              >
                <Button size="small" danger style={{ fontSize: 12 }}>
                  Remove
                </Button>
              </Popconfirm>
            ) : null}
          </div>
        );
      },
    },
  ];

  return (
    <div>
      <Table
        columns={columns}
        dataSource={sortedData}
        pagination={false}
        size="small"
      />
      <div style={{ float: "right" }}>
        <Pagination
          responsive
          defaultCurrent={props?.page}
          total={props?.meta}
          pageSize={props?.pagesize}
          onChange={props?.onPageChange}
          showTotal={(total, range) => {
            return `Showing ${range[0]}-${range[1]} of ${total} items`;
          }}
        />
      </div>
    </div>
  );
}

export default DataTable;
